module.exports = __webpack_public_path__ + "img/Beach.6967c1fc.jpeg";